<!-- ESTRUTURA DE TELA BÁSICA DO CODEX, NÃO DEVE SER RETIRADO OU ADICIONADO ELEMENTOS DENTRO DESTA ESTRUTURA -->
<div
  class="cdxWrapper cdxWrapper--japao"
  [ngClass]="{'cdxWrapper--asideLeftToggle' : showLeft, 'cdxWrapper--viewer' : showViewer, 'cdxWrapper--asideLeftHidden' : hideLeft,'cdxWrapper--topHidden' : hideTop}">

  <cdx-header [hideHamburger]="hideLeft" *ngIf="!hideTop"></cdx-header>
  <cdx-navbar [class.sign-free]="isSignFree" [options]="navbarOptions" *ngIf="!hideTop"></cdx-navbar>
  <cdx-aside-left [options]="leftOptions" [userOptions]="navbarOptions" (ItemClick)="sideItemClick($event)" (ItemCAClick)="sideItemClick($event)" (ItemTreeviewClick)="sideItemClick($event)" *ngIf="!hideLeft"></cdx-aside-left>
  <cdx-navigation></cdx-navigation>
  <cdx-title *ngIf="!hideTop"></cdx-title>
  <cdx-toolbar [defaultrow]="toolbarRef? toolbarRef : defaultrow"></cdx-toolbar>
  <cdx-content class="container-grid" [infiniteScrollOptions]="infiniteScrollOptions"></cdx-content>

  <div class="bg__backdrop--sidebar" ></div>
  <cdx-loading [text]="'label.loading'" [zindex]="999999"></cdx-loading>
</div>

<cdx-onboarding onboardingId="whatsappChangeOnboarding" [options]="whatsappChangeOnboarding" [showOnboarding]="showEhatsappChangeOnboarding" (closeOnboarding)="handleWhatsAppOnboardingView()" ></cdx-onboarding>
<cdx-toast></cdx-toast>
<app-button-baseboard *ngIf="isWhatsAppButton"></app-button-baseboard>
<app-button-add-envelope *ngIf="canShowAddEnvelope"></app-button-add-envelope>
<ng-template #defaultrow></ng-template>
